import { useTranslation } from "react-i18next";
import { assetPath } from "../../utils/assets";

function TransactionStatus({ status, type, method, title, message, onPrimaryAction, primaryTitle, onSecondaryAction, secondaryTitle, amount }) {
    const { t } = useTranslation();
    const iconName = 
        status === 'success' ? 'success' : 
        status === 'unsuccess' ? 'unsuccess' : 
        'warning';

    const icon = (
        <img
            src={assetPath(`/icons/${iconName}.png`)}
            className="size-[80px]"
            alt=""
        />
    );

    const handlePrimaryAction = () => {
        if (onPrimaryAction) {
            onPrimaryAction(status);
        }
    };

    const handleSecondaryAction = () => {
        if (onSecondaryAction) {
            onSecondaryAction();
        }
    };

    return (
        <div className="bg-secondary flex-col flex-center p-4">
            <div className="p-8">
                {icon}
            </div>

            <h1 className="text-4xl font-bold text-white text-center mb-6">
                {t(title)}
            </h1>

            {/* {status === "fail" ? (
                <div className="mb-12 w-full">
                    <div className="bg-primary container-equal-sm rounded-lg border-2 border-border-yellow gap-2">
                        <RiInformation2Fill className="size-lg text-border-yellow" />
                        <div className="flex flex-col flex-grow">
                            <span className="text-xs text-white">
                                {t("UseCryptocurrencyMethod")}.
                            </span>
                        </div>
                    </div>
                </div>
            ) : (
                )} */}
            <p className= {`text-center mb-6 ${iconName === 'warning' ? 'text-white' : 'text-color-blue'}`}>
                {t(message, { amount })}
            </p>
            
            {onPrimaryAction && (
            <button className="w-full container-equal-md gap-2 rounded-sm btn-gradient-border mb-3" onClick={handlePrimaryAction}>
                <span className="font-bold">
                    {primaryTitle}
                </span>
            </button>
            )}
            
            {onSecondaryAction && (
                <button className="w-full container-equal-md gap-2 rounded-sm bg-dropdown-bg mb-3" onClick={handleSecondaryAction}>
                    <span className="font-bold text-white">
                        {secondaryTitle}
                    </span>
                </button>
            )}
            {/* {(status === "fail" || status === "cryptoFail") && (
                <div className="flex w-full mb-3">
                    <button className="w-full container-equal-md gap-2 rounded-sm bg-dropdown-bg mb-3" onClick={handleSecondaryAction}>
                        <span className="font-bold text-white">
                        {secondaryLabel}
                        </span>
                    </button>
                </div>
            )} */}
        </div>
    );
}

export default TransactionStatus;
